import React from 'react';
import { Space, Button, Tooltip } from 'antd';
import { 
  UndoOutlined, 
  DeleteOutlined,
  EyeOutlined 
} from '@ant-design/icons';

/**
 * Arşivlenmiş formlar için aksiyon butonları
 */
const ActionButtons = ({ 
  record, 
  onRestore, 
  onDelete, 
  onPreview 
}) => {
  return (
    <Space size="small">
      {/* Geri Yükle Butonu */}
      <Tooltip title="Formu geri yükle">
        <Button
          type="primary"
          icon={<UndoOutlined />}
          size="small"
          onClick={() => onRestore(record)}
        >
          Geri Yükle
        </Button>
      </Tooltip>

      {/* Önizleme Butonu */}
      <Tooltip title="Form önizlemesi">
        <Button
          icon={<EyeOutlined />}
          size="small"
          onClick={() => onPreview && onPreview(record)}
        >
          Önizle
        </Button>
      </Tooltip>

      {/* Kalıcı Silme Butonu */}
      <Tooltip title="Kalıcı olarak sil">
        <Button
          danger
          icon={<DeleteOutlined />}
          size="small"
          onClick={() => onDelete(record.id)}
        >
          Sil
        </Button>
      </Tooltip>
    </Space>
  );
};

export default ActionButtons;
